// removed by extract-text-webpack-plugin
module.exports = {"mailName":"_1Mx9wYT9jY","row":"_34ajPTvOZM","table":"_4kL5o8p0NF"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Account/BalanceSummary/BalanceSummary.module.less
// module id = 970
// module chunks = 3